import { initialState } from '@/vuex/modules/simulation/index'
import _cloneDeep from 'lodash/cloneDeep'

const mutations = {
  SET_CURRENT_STEP(state, step) {
    state.currentStep = step
  },
  SET_MODE(state, mode) {
    state.mode = mode
  },
  RESET(state) {
    state.currentStep = 1
  },
  SELECT_GROUP(state, locationGroup) {
    state.selectedGroup = locationGroup
    state.selectedLocation = initialState.selectedLocation
  },
  DESELECT_GROUP(state) {
    state.selectedGroup = { id: null, type: null }
  },
  SET_LAST_DRAG_END_TIME(state) {
    state.lastDragEndTime = new Date().getTime()
  },
  SET_FIT_BOUNDS(state, triggerOn) {
    state.fitBounds = triggerOn
  },
  SET_MAP_CENTER(state, latLng) {
    const { lat, lng } = latLng
    state.mapCenter.latitude = lat
    state.mapCenter.longitude = lng
  },
  SET_MAP_ZOOM(state, zoom) {
    state.mapZoom = zoom
  },
  SELECT_LOCATION(state, location) {
    state.selectedLocation = location
  },
  DESELECT_LOCATION(state) {
    state.selectedLocation = initialState.selectedLocation
  },
  UPDATE_SELECTED_LOCATION(state, location) {
    state.selectedLocation = location
  },
  SET_LAST_SETTING_AREA_HEIGHT(state, height) {
    state.lastSettingAreaHeight = height
  },
  SEARCH_LOCATION({ search }) {
    search.isSearching = true
  },
  SEARCH_LOCATION_FAILURE({ search }) {
    search.isSearching = false
    search.results = []
  },
  SEARCH_LOCATION_SUCCESS({ search }, results) {
    search.isSearching = false
    search.results = results
  },
  SET_FOCUS_INDEX({ search }, index) {
    search.forcedResultIndex = index
  },
  FOCUS_MOVE_SEARCH_RESULT({ search }, nextIndex) {
    search.forcedResultIndex = nextIndex
  },
  FOCUS_OUT_SEARCH_RESULT({ search }) {
    search.forcedResultIndex = null
  },
  CLEAR_SEARCH_RESULT(state) {
    state.search = _cloneDeep(initialState.search)
  },
  SELECT_POINT_GROUP_TYPE({ pointGroupImport }, type) {
    pointGroupImport.selectedPointGroupType = type
    pointGroupImport.pointGroupList = []
    pointGroupImport.IOList = []
    pointGroupImport.selectedAdvertiserId = null
    pointGroupImport.selectedOwnerProfileId = null
  },
  FETCH_POINT_GROUP_LIST_SUCCESS({ pointGroupImport }, pointGroupList) {
    pointGroupImport.pointGroupList = pointGroupList
  },
  FETCH_ADVERTISER_LIST({ pointGroupImport }, advertiserList) {
    pointGroupImport.advertiserList = advertiserList
  },
  SELECT_ADVERTISER({ pointGroupImport }, advertiserId) {
    pointGroupImport.selectedAdvertiserId = advertiserId
  },
  FETCH_IO_LIST_SUCCESS({ pointGroupImport }, IOList) {
    pointGroupImport.IOList = IOList
  },
  SELECT_IO({ pointGroupImport }, ownerProfileId) {
    pointGroupImport.selectedOwnerProfileId = ownerProfileId
  },
  ADD_GROUP({ pointGroupImport }, pointGroup) {
    pointGroupImport.selectedPointGroup = pointGroup
    pointGroupImport.selectedPointGroupList.push(pointGroup)
  },
  SELECT_POINT_GROUP({ pointGroupImport }, pointGroup) {
    pointGroupImport.selectedPointGroup = pointGroup
  },
  FETCH_LOCATION_LIST_SUCCESS({ pointGroupImport }, { locations, groupId }) {
    pointGroupImport.selectedLocationsMap.set(groupId, locations)
    pointGroupImport.selectedPointGroupLocationList = locations
  },
  REMOVE_POINT_GROUP({ pointGroupImport }, pointGroupId) {
    const pointGroupList = pointGroupImport.selectedPointGroupList
    pointGroupImport.selectedPointGroupList = pointGroupList.filter(
      g => g.id !== pointGroupId,
    )
    pointGroupImport.selectedLocationsMap.delete(pointGroupId)
  },
  SET_POINT_GROUP_IMPORT_MAP_CENTER({ pointGroupImport }, lngLat) {
    const { lat, lng } = lngLat
    pointGroupImport.mapCenter.latitude = lat
    pointGroupImport.mapCenter.longitude = lng
  },
  POINT_GROUP_IMPORT_DESTROY_MODAL_VALUES(state) {
    state.pointGroupImport = _cloneDeep(initialState.pointGroupImport)
  },
}

export default mutations
